export const METROS = {
  "All Metros": ["Bexar","Comal","Guadalupe","Kendall","Travis","Williamson","Hays","Bastrop","Caldwell","Harris","Fort Bend","Montgomery","Brazoria","Galveston","Dallas","Tarrant","Collin","Denton","Rockwall"],
  "San Antonio": ["Bexar","Comal","Guadalupe","Kendall"],
  "Austin": ["Travis","Williamson","Hays","Bastrop","Caldwell"],
  "Houston": ["Harris","Fort Bend","Montgomery","Brazoria","Galveston"],
  "Dallas–Fort Worth": ["Dallas","Tarrant","Collin","Denton","Rockwall"],
};
export const METRO_NAMES = Object.keys(METROS);
